import { z } from "zod";

export const CollegeAcceptanceStatus = {
	ACCEPTED: "Accepted",
	NOT_ACCEPTED: "Not accepted",
	APPLIED: "Applied",
} as const;

export type CollegeAcceptanceStatus = (typeof CollegeAcceptanceStatus)[keyof typeof CollegeAcceptanceStatus];

export const COLLEGE_ACCEPTANCE_STATUSES = Object.values(CollegeAcceptanceStatus) as readonly CollegeAcceptanceStatus[];

export const collegeAcceptanceStatusSchema = z.enum(CollegeAcceptanceStatus);
